

















import { Vue, Component, Prop } from "vue-property-decorator";

export type TalentPoolIconColor =
  | "white"
  | "primary"
  | "accent"
  | "grey"
  | "black";

@Component
export default class TalentPoolIcon extends Vue {
  @Prop({ type: String, default: "white" })
  readonly color!: TalentPoolIconColor;

  @Prop({ type: Boolean, default: false })
  readonly xLarge!: Boolean;

  @Prop({ type: Boolean, default: false })
  readonly large!: Boolean;

  @Prop({ type: Number, default: null })
  readonly size!: number | null;

  get imageSrc(): string {
    switch (this.color) {
      case "white":
        return "/Kandidatpool_White.svg";
      case "primary":
        return "/Kandidatpool_Blue.svg";
      case "accent":
        return "/Kandidatpool_Pink.svg";
      case "grey":
        return "/Kandidatpool_Grey.svg";
      case "black":
        return "/Kandidatpool_Black.svg";
    }
  }

  get width(): string {
    if (this.size !== null) {
      return this.size + "px";
    }
    if (this.xLarge) {
      return 60 + "px";
    }
    if (this.large) {
      return 30 + "px";
    }
    return 24 + "px";
  }
}
